<template>
  <div style="height: 100%">
    <div v-if="showTip">
      <mt-header class="nav-header" :title="title">
        <div slot="right" @click="home"><img class="icon" src="../../static/image/shouye.png" alt=""/></div>
      </mt-header>
      <div class="icon" style="color: #777676;margin-top:18px;border-bottom:1px solid #ccc;padding-bottom:10px;text-align:center">
        <i class="iconfont icon-dizhi">{{address}}</i>
      </div>
      <div class="show-tip">
        <QrcodeQuickEntry v-if="serviceQrcodeList.length>0" :serviceQrcodeList="serviceQrcodeList"></QrcodeQuickEntry>
        <div v-else>对不起，管理员太忙了，还没来得及在后台配置服务。</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations,mapGetters} from 'vuex';
  import QrcodeQuickEntry from '@/components/QrcodeQuickEntry';

  export default {
    data() {
      return{
        showTip: false,
        title: '',
        serviceQrcodeList: [],
        address: "",
      };
    },
    methods: {
      ...mapMutations(['change_currentParkId', 'change_qrcodeServiceInfo']),
      getInfo() {
        this.$http.post(`${this.URL_PREFIX}/app/get/park/qrcode/detail`, {
          parkId: this.$route.params.parkId,
          qrId: this.$route.params.qrId,
        }, {
          headers: { token: this.token, }
        }).then((res) => {
          if(res.data.resCode === '10000') {
            let data = res.data.resData;
            this.title = data.title;
            this.change_qrcodeServiceInfo(data);
            let path = this.getDetailPath(data.serviceFlag, data.serviceType, data.serviceId, data.serviceInfoId);
            if(path){
              this.$router.push({path: path, query:{qrId: data.qrId} });
            }else{
              this.serviceQrcodeList = data.serviceQrcodeList;
              this.address = data.address;
              this.showTip = true;
            }
          }
        });
      },
      getDetailPath(serviceFlag, serviceType, serviceId, serviceInfoId) {
        let typePath = {
          10: `/propertyDetiles/${serviceId}`,// 入驻
          11: `/business/recommendInfo/${serviceInfoId}`,// 优选服务
          12: `/business/OfficeDetalis/${serviceInfoId}`,// 会议室
          13: `/ActivitiesDetalis/${serviceInfoId}`,// 活动
          14: `/exclusiveDetalis/${serviceInfoId}`,// 福利
          16: `/business/equipmentInfo/${serviceId}/${serviceInfoId}`,// 自定义设施出租
          18: `/propertyDetiles/${serviceId}`,// 物业报修
        }
        let flagPath = {
          1: `/propertyDetiles/${serviceId}`,// 物业服务
          3: `/governmentDetiles/${serviceId}`,// 政务平台
          4: `/financeDetalis/${serviceId}`,// 金融服务
        }
        return serviceType==3 ? flagPath[serviceFlag] : typePath[serviceType];
      },
      home() {
        window.location.href = `${this.URL_PREFIX_PAGE}/index?parkId=${this.currentParkId}`;
      },
    },
    created() {
      if(this.$route.params.parkId){
        this.change_currentParkId(Number(this.$route.params.parkId));
      }
      this.change_qrcodeServiceInfo({});
      this.getInfo();
    },
    computed: {
    ...mapGetters(['currentParkId']),
  },
  }
</script>
<style lang="scss" scoped>
.nav-header{
  height: 1.173333rem;
  font-weight: bold;
  font-size: .453333rem;
  text-align: center;
  background-color: #fff;
  color: rgb(55, 55, 55);
  border-bottom: 1px solid rgb(246, 246, 246);
  .icon{
    width: .753333rem;
  }
}
.show-tip{
  margin-top: 20px;
  text-align: center;
  vertical-align: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/qrcode/Qrcode.vue